/* GRIMM interaction tracking v1.1 – respects Shopify analytics consent.
   Adds stable data-attr hooks without affecting shopping behavior. */
(function () {
  'use strict';
  if (window.__grimmInteractionTracking) return;
  window.__grimmInteractionTracking = true;

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.currentVisitorConsent === 'function' &&
        privacy.currentVisitorConsent().analytics === 'yes');
    } catch (e) { return false; }
  }
  function track(name, properties) {
    if (!allowed()) return;
    var payload = Object.assign({
      tracking_schema: 'grimm_v2',
      customer_type: document.documentElement.dataset.grimmCustomerType || 'b2c',
      is_preview: document.documentElement.dataset.grimmThemeRole !== 'main',
      page_path: window.location.pathname,
      tracking_source: 'grimm_theme'
    }, properties || {});
    try {
      var ph = window.posthog;
      if (ph && ph.__loaded && typeof ph.capture === 'function' &&
          typeof ph.has_opted_out_capturing === 'function' && !ph.has_opted_out_capturing()) {
        ph.capture(name, payload);
      }
    } catch (e) { /* PostHog must never affect the storefront. */ }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    } catch (e) { /* GA4 must never affect the storefront. */ }
  }
  window.grimmTrack = track;
  function pathFor(link) {
    try { return new URL(link.href, window.location.origin).pathname; }
    catch (e) { return ''; }
  }
  function handleFromPath(path) {
    var match = (path || '').match(/\/products\/([^\/?#]+)/);
    try { return match ? decodeURIComponent(match[1]).slice(0, 120) : ''; }
    catch (e) { return ''; }
  }
  function cardHandle(element) {
    var card = element.closest('product-card');
    if (!card) return '';
    return (card.getAttribute('data-grimm-product-handle') ||
      handleFromPath((card.querySelector('a.js-prod-link[href]') || {}).href || '')).slice(0, 120);
  }
  function setTag(selector, value) {
    document.querySelectorAll(selector).forEach(function (element) {
      if (!element.hasAttribute('data-attr')) element.setAttribute('data-attr', value);
    });
  }
  function decorate() {
    setTag('product-card .card__quick-add button, product-card [data-quick-buy-add-to-cart]', 'grimm-quick-buy');
    setTag('.grimm-gift-upgrade a[href]', 'grimm-gift-upgrade');
    setTag('.grimm-compact-offer a[href]', 'grimm-package-upgrade');
    setTag('.grimm-package-hint[href]', 'grimm-package-hint');
    setTag('carousel-slider .slider-nav__btn', 'grimm-carousel-navigation');
    setTag('carousel-slider product-card a.js-prod-link[href], carousel-slider product-card-mini a[href]', 'grimm-carousel-product');
    setTag('.article__content a[href]', 'grimm-article-link');
    setTag('[data-ghr-goal]', 'grimm-hairguide-goal');
    setTag('[data-ghr-length]', 'grimm-hairguide-length');
    setTag('[data-ghr-traits] input', 'grimm-hairguide-trait');
    setTag('[data-ghr-result] a[href]', 'grimm-hairguide-product');
    setTag('[data-ghr-add], [data-ghr-bulk]', 'grimm-hairguide-action');
    watchGuideResults();
    watchDealerLinks();
    reportSearch();
  }
  var dealerLinks = new WeakSet();
  var dealerObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting || !allowed()) return;
      track('grimm_dealer_cta_view', {destination_path: pathFor(entry.target)});
      dealerObserver.unobserve(entry.target);
    });
  }, {threshold: 0.5}) : null;
  function watchDealerLinks() {
    if (!dealerObserver || !allowed()) return;
    document.querySelectorAll('a[href*="/apps/salongpartner/b2b-form"],a[href*="/pages/forhandlerportal"]').forEach(function(link) {
      if (dealerLinks.has(link)) return;
      dealerLinks.add(link); dealerObserver.observe(link);
    });
  }
  document.addEventListener('visitorConsentCollected', watchDealerLinks);
  var searchReported = false;
  function reportSearch() {
    var meta = document.querySelector('[data-grimm-search-meta]');
    if (searchReported || !allowed() || !meta || meta.dataset.searchPerformed !== 'true') return;
    searchReported = true;
    track('grimm_search_results_view', {result_count:Number(meta.dataset.resultCount)||0,search_surface:'native'});
  }
  document.addEventListener('visitorConsentCollected', reportSearch);
  var guides = new WeakSet();
  function watchGuideResults() {
    document.querySelectorAll('[data-ghr]').forEach(function (root) {
      if (guides.has(root)) return;
      var result = root.querySelector('[data-ghr-result]');
      if (!result) return;
      guides.add(root);
      var done = false;
      function checkCompletion() {
        if (done || !allowed() || !root.dataset.grimmPosthogStarted || !result.querySelector('.ghr-result-kicker')) return;
        done = true;
        track('grimm_hairguide_complete', {
          guide_id: root.getAttribute('data-ghr') || 'unknown'
        });
      }
      new MutationObserver(checkCompletion).observe(result, { childList: true, subtree: true });
      checkCompletion();
    });
  }
  function guideMeta(element) {
    var root = element.closest('[data-ghr]');
    return root ? {guide_id: root.getAttribute('data-ghr') || 'unknown'} : {};
  }
  function onClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var dealer = target.closest('a[href*="/apps/salongpartner/b2b-form"],a[href*="/pages/forhandlerportal"]');
    if (dealer) track('grimm_dealer_cta_click', {destination_path:pathFor(dealer)});

    // Hair guide recommendations: mutually exclusive with general CTA classification.
    var guideAction = target.closest('[data-ghr-result] a[href], [data-ghr-add], [data-ghr-bulk]');
    if (guideAction && guideAction.closest('[data-ghr]')) {
      var action = guideAction.hasAttribute('data-ghr-add') ? 'add_to_cart' :
        guideAction.hasAttribute('data-ghr-bulk') ? 'routine_add' : 'view_product';
      // data-ghr-add contains an internal guide key, not a Shopify handle.
      // Resolve the adjacent product link to preserve accurate product attribution.
      var guideProduct = guideAction.closest('.ghr-product');
      var guideProductLink = guideProduct && guideProduct.querySelector('a.ghr-link[href]');
      var guideItemKey = guideAction.getAttribute('data-ghr-add') || '';
      var targetHandle = guideItemKey ?
        handleFromPath(pathFor(guideProductLink)) : handleFromPath(pathFor(guideAction));
      track('grimm_hairguide_recommendation_click', Object.assign(guideMeta(guideAction), {
        guide_action: action,
        target_handle: targetHandle,
        guide_item_key: guideItemKey.slice(0, 80)
      }));
      return;
    }

    var upgrade = target.closest('.grimm-gift-upgrade a[href], .grimm-compact-offer a[href], a.grimm-package-hint[href]');
    if (upgrade) {
      var category = upgrade.closest('.grimm-gift-upgrade') ? 'giftbox' :
        upgrade.closest('.grimm-compact-offer') ? 'package' : 'collection_hint';
      track('grimm_package_recommendation_click', {
        placement: category,
        source_handle: handleFromPath(window.location.pathname) || cardHandle(upgrade),
        destination_handle: handleFromPath(pathFor(upgrade))
      });
      return;
    }

    var quick = target.closest('product-card .card__quick-add button, product-card [data-quick-buy-add-to-cart]');
    if (quick && !quick.disabled) {
      track('grimm_quick_buy_click', {
        product_handle: cardHandle(quick),
        quick_buy_action: quick.matches('.js-quick-add') ? 'choose_options' : 'add_to_cart',
        location: quick.closest('carousel-slider') ? 'carousel' : 'product_grid'
      });
      return;
    }

    var sliderButton = target.closest('carousel-slider .slider-nav__btn');
    if (sliderButton && !sliderButton.disabled) {
      track('grimm_product_carousel_click', {
        interaction: 'navigate',
        direction: sliderButton.getAttribute('name') || 'unknown'
      });
      return;
    }
    var carouselLink = target.closest('carousel-slider product-card a[href], carousel-slider product-card-mini a[href]');
    if (carouselLink) {
      track('grimm_product_carousel_click', {
        interaction: 'open_product',
        target_handle: handleFromPath(pathFor(carouselLink))
      });
      return;
    }

    var articleLink = target.closest('.article__content a[href]');
    if (articleLink) {
      var dest = pathFor(articleLink);
      track('grimm_article_link_click', {
        article_path: window.location.pathname,
        destination_path: dest,
        destination_type: dest.indexOf('/products/') >= 0 ? 'product' :
          dest.indexOf('/collections/') >= 0 ? 'collection' : 'other'
      });
    }
  }
  function onChange(event) {
    var target = event.target;
    if (!target || typeof target.matches !== 'function') return;
    if (!target.matches('[data-ghr-goal], [data-ghr-length], [data-ghr-traits] input, [data-ghr-followup] select, [data-ghr-followup] input')) return;
    var root = target.closest('[data-ghr]');
    if (!root || !allowed()) return;
    if (!root.dataset.grimmPosthogStarted) {
      root.dataset.grimmPosthogStarted = '1';
      track('grimm_hairguide_start', guideMeta(target));
    }
    var step = target.matches('[data-ghr-goal]') ? 'goal' :
      target.matches('[data-ghr-length]') ? 'length' :
      !!target.closest('[data-ghr-traits]') ? 'traits' : 'followup';
    // Do not transmit raw field values or customer-entered text.
    track('grimm_hairguide_step_change', Object.assign(guideMeta(target), {guide_step: step}));
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('change', onChange, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate, {once: true});
  } else { decorate(); }
  document.addEventListener('shopify:section:load', decorate);
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; decorate(); });
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
